import { useState } from "react";

function useMultiSelect<T>(items: T[]) {
  const [selectedIndexes, setSelectedIndexes] = useState<number[]>([]);

  const handleSelect = (index: number, isSelected: boolean) => {
    setSelectedIndexes((prev) => (isSelected ? [...prev, index] : prev.filter((i) => i !== index)));
  };

  const handleSelectAll = (isSelected: boolean) => {
    setSelectedIndexes(isSelected ? items.map((_, index) => index) : []);
  };

  const resetSelection = () => {
    setSelectedIndexes([]);
  };

  return { selectedIndexes, handleSelect, handleSelectAll, setSelectedIndexes, resetSelection };
}

export { useMultiSelect };
